<div 
    class="type-pill" 
    [style.color]="textColor" 
    [style.background]="backgroundColor" 
    [style.border-color]="textColor">
    {{text}}
</div>